{
  "valid": "Érvényes"
}
